import {BehaviorSubject} from "rxjs";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class CartHeaderService {
  public headerEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public backButtonEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public nextStepButtonEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public constructor() {}
}
